var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 22,
    viewBox: "0 0 15 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.66735 22.0002C5.69094 22.0002 7.33327 20.3575 7.33327 18.3335V14.6667H3.66735C1.64377 14.6667 0.00143433 16.3094 0.00143433 18.3335C0.00143433 20.3575 1.64377 22.0002 3.66735 22.0002Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00143433 10.9999C0.00143433 8.97591 1.64377 7.33325 3.66735 7.33325H7.33327V14.6666H3.66735C1.64377 14.6666 0.00143433 13.0239 0.00143433 10.9999Z",
    fill: "#B053FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00146484 3.66667C0.00146484 1.64267 1.6438 0 3.66738 0H7.3333V7.33333H3.66738C1.6438 7.33333 0.00146484 5.69067 0.00146484 3.66667Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33334 0H10.9993C13.0229 0 14.6652 1.64267 14.6652 3.66667C14.6652 5.69067 13.0229 7.33333 10.9993 7.33333H7.33334V0Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6652 10.9999C14.6652 13.0239 13.0229 14.6666 10.9993 14.6666C8.97569 14.6666 7.33334 13.0239 7.33334 10.9999C7.33334 8.97591 8.97569 7.33325 10.9993 7.33325C13.0229 7.33325 14.6652 8.97591 14.6652 10.9999Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6667,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.c03132cf.svg";
export { ForwardRef as ReactComponent };